export const compareDates = (a, b, order) => {
  const dateA = Date.parse(a.upload_date);
  const dateB = Date.parse(b.upload_date);

  if (isNaN(dateA) && isNaN(dateB)) return 0;
  if (isNaN(dateA)) return order === "descending" ? 1 : -1;
  if (isNaN(dateB)) return (order = "ascending" ? -1 : 1);

  return order === "ascending" ? dateA - dateB : dateB - dateA;
};
